import { type SeededRandom, seededRandom } from "./seeded-random";
import { escapeXml, svgDataUrl } from "./svg";

export type GeneratedAvatarOptions = {
  seed: string;
  name?: string;
  email?: string;
  size?: number;
};

const GRID = 6;

export const avatarInitials = (name?: string, email?: string): string => {
  const trimmedName = name?.trim();
  if (trimmedName) {
    const parts = trimmedName.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0]?.[0] ?? ""}${parts[parts.length - 1]?.[0] ?? ""}`.toUpperCase();
    }
    return (trimmedName[0] ?? "").toUpperCase();
  }
  const trimmedEmail = email?.trim();
  if (trimmedEmail) {
    return trimmedEmail[0]?.toUpperCase() ?? "?";
  }
  return "?";
};

const mirroredBlocks = (random: SeededRandom, size: number): string => {
  const cell = size / GRID;
  const half = Math.ceil(GRID / 2);
  const blocks: string[] = [];

  for (let row = 0; row < GRID; row++) {
    for (let column = 0; column < half; column++) {
      if (!random.bool(0.45)) {
        continue;
      }
      const x = column * cell;
      const mirroredX = (GRID - 1 - column) * cell;
      const y = row * cell;
      blocks.push(`<rect x="${x}" y="${y}" width="${cell}" height="${cell}"/>`);
      if (mirroredX !== x) {
        blocks.push(`<rect x="${mirroredX}" y="${y}" width="${cell}" height="${cell}"/>`);
      }
    }
  }

  return blocks.join("");
};

export const createAvatarDataUrl = ({ seed, name, email, size = 96 }: GeneratedAvatarOptions): string => {
  const random = seededRandom(seed);
  const hue = random.int(0, 360);
  const secondHue = (hue + random.int(40, 110)) % 360;
  const initials = escapeXml(avatarInitials(name, email));
  const fontSize = Math.round(size * 0.4);
  const svg = [
    `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">`,
    `<defs><linearGradient id="a" x1="0" y1="0" x2="1" y2="1">`,
    `<stop offset="0" stop-color="hsl(${hue}, 64%, 54%)"/>`,
    `<stop offset="1" stop-color="hsl(${secondHue}, 58%, 36%)"/>`,
    `</linearGradient></defs>`,
    `<rect width="${size}" height="${size}" fill="url(#a)"/>`,
    `<g fill="#ffffff" opacity="0.16">${mirroredBlocks(random, size)}</g>`,
    `<text x="${size / 2}" y="${size / 2 + fontSize * 0.35}" text-anchor="middle" fill="#ffffff" font-family="system-ui, -apple-system, 'Segoe UI', sans-serif" font-size="${fontSize}" font-weight="600">${initials}</text>`,
    `</svg>`,
  ].join("");

  return svgDataUrl(svg);
};
